import * as Sentry from '@sentry/react'

export function retryDelay(attemptIndex: number) {
  const baseDelay = Math.min(1000 * 2 ** attemptIndex, 30_000)

  // add jitter (randomness) to prevent thundering herd problem
  const jitter = 0.75 + Math.random() * 0.5
  const finalDelay = Math.floor(baseDelay * jitter)

  if (!isOnline()) {
    Sentry.addBreadcrumb({
      category: 'network',
      message: `Retry delayed due to offline status (attempt ${attemptIndex})`,
      level: 'warning',
      data: {
        attemptIndex,
        offline: true,
      },
    })

    // if we're offline, use a longer delay (20s) to avoid wasting resources
    return 20_000
  }

  Sentry.addBreadcrumb({
    category: 'query.retry',
    message: `Calculating retry delay for attempt ${attemptIndex}`,
    level: 'info',
    data: {
      attemptIndex,
      baseDelay,
      jitterFactor: jitter,
      finalDelay,
      isOnline: isOnline(),
    },
  })

  return finalDelay
}

function isOnline() {
  return navigator.onLine
}
